import $ from "jquery";
import Events from "../classes/Events";

let PasswordPlugin = Events.extend("PasswordPlugin", {
    init($input) {
        let $clone = $input.clone().show();

        $input.hide();
        $input.after($clone);

        $clone.removeAttr("name"); // без этой строчки логин сломается (just saying)
        $clone.removeAttr("id"); // убирает DOM warning из консоли
        $clone.addClass("cloned");

        this.$input = $input;
        this.$clone = $clone;
        this.letters = [];

        // переопределяем символы, которые вводят в клон на шарик
        this.listenTo(this.$clone, "input", this.onInput);
        // синхронизация классов между клоном и оригиналом
        this.listenTo(this.$input, "cssClassAdded cssClassRemoved", this.onChangeClassName);
        // очень раздражает, когда по dblclick выделяется только один символ,
        // поэтому сделал такую штуку
        this.listenTo(this.$clone, "dblclick", this.onDblclick);
    },

    onInput() {
        let $input = this.$input;
        let $clone = this.$clone;

        let value = $clone.val();

        let letters = this.letters.slice(0, value.length);

        for (let i = 0; i < value.length; i++) {
            let char = value[i];
            if ( char !== MASK ) {
                letters[i] = char;
            }
        }

        $clone.val(MASK.repeat(value.length));
        $input.val(letters.join(""));

        this.letters = letters;
    },

    onDblclick() {
        this.$clone.select();
    },

    onChangeClassName() {
        let $input = this.$input;
        let $clone = this.$clone;

        let classList = $input.attr("class") || "";

        let className;

        for (className of classList.split(/\s+/)) {
            if ( !$clone.hasClass(className) ) {
                $clone.addClass(className);
            }
        }
        let clonedClassList = $clone.attr("class") || "";
        for ( className of clonedClassList.split(/\s+/) ) {
            if ( !$input.hasClass(className) ) {
                $clone.removeClass(className);
            }
        }
    }
});

let MASK = "\u25CF";
let originalAddClassMethod = $.fn.addClass;
let originalRemoveClassMethod = $.fn.removeClass;

$.fn.addClass = function() {
    let result = originalAddClassMethod.apply(this, arguments);
    $(this).trigger("cssClassAdded", result);
    return result;
};

$.fn.removeClass = function() {
    let result = originalRemoveClassMethod.apply(this, arguments);
    $(this).trigger("cssClassRemoved");
    return result;
};

$.fn.password = function(method) {
    return this.each(function() {
        let $input = $(this);

        let passwordPlugin = $input.data("PasswordPlugin");

        if ( method == "destroy" ) {
            if ( passwordPlugin ) {
                passwordPlugin.destroy();
            }
            $input.data("PasswordPlugin", null);
        } else {
            passwordPlugin = new PasswordPlugin($input);
            $input.data("PasswordPlugin", passwordPlugin);
        }
    });
};

export default $.fn.password;
